
import React from "react";
import { TableHead, TableRow } from "@/components/ui/table";
import { ArrowUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SortField } from "./tableUtils";

// Match the column filters type from StrategiesTableProvider
type ColumnFilters = {
  name: string;
  exchange: string;
  minInvestment: string;
  riskLevel: string;
};

interface TableHeaderProps {
  onSort: (field: SortField) => void;
  columnFilters: ColumnFilters;
  onFilterChange: (field: keyof ColumnFilters, value: string) => void;
}

const TableHeaderRow = ({ onSort, columnFilters, onFilterChange }: TableHeaderProps) => {
  return (
    <TableRow>
      <TableHead>
        <Button variant="ghost" onClick={() => onSort('name')}>
          Strategy Name <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
        <Input
          placeholder="Filter name..."
          value={columnFilters.name}
          onChange={(e) => onFilterChange('name', e.target.value)}
          className="mt-2"
        />
      </TableHead>
      <TableHead>
        <Button variant="ghost" onClick={() => onSort('exchange')}>
          Exchange <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
        <Input
          placeholder="Filter exchange..."
          value={columnFilters.exchange}
          onChange={(e) => onFilterChange('exchange', e.target.value)}
          className="mt-2"
        />
      </TableHead>
      <TableHead>
        <Button variant="ghost" onClick={() => onSort('risk_level')}>
          Risk Level <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
        <Input
          placeholder="Filter risk level..."
          value={columnFilters.riskLevel}
          onChange={(e) => onFilterChange('riskLevel', e.target.value)}
          className="mt-2"
        />
      </TableHead>
      <TableHead className="text-right">
        <Button variant="ghost" onClick={() => onSort('min_investment')} className="w-full justify-end">
          Min Investment <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
        <Input
          placeholder="Filter min investment..."
          value={columnFilters.minInvestment}
          onChange={(e) => onFilterChange('minInvestment', e.target.value)}
          className="mt-2"
        />
      </TableHead>
      <TableHead>Provider</TableHead>
      <TableHead>Plan</TableHead>
      <TableHead>Status</TableHead>
      <TableHead>Approval</TableHead>
      <TableHead>
        <Button variant="ghost" onClick={() => onSort('created_at')}>
          Created At <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      </TableHead>
      <TableHead>Actions</TableHead>
    </TableRow>
  );
};

export default TableHeaderRow;
